import { css } from 'emotion';

import type { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';

import { colors, fonts, icons } from '../../styles';
import GeofenceTypeItems from '../GeofenceTypeItems';

export const cluster = css`
  display: flex;
  flex: 1;
  max-width: 80px;
  width: fit-content;
  min-width: 40px;
  padding: 3px;
  border-radius: 10px;
  color: ${colors.white};
  height: ${icons.size.medium};
  background: ${colors.secondary.default};
  border: 1px solid ${colors.white};
  font-weight: ${fonts.weight.medium};
  filter: drop-shadow(
    0px 4px 4px ${colors.shadows.getShadow(colors.secondary.default, 0.2)}
  );
  transform: translateX(-50%);
  align-items: center;
  cursor: pointer;
  padding-right: 6px;

  & > div {
    min-width: 14px;
    text-align: center;
  }
`;

export const pinContainer = (type?: GeofenceType) => css`
  color: ${type ? GeofenceTypeItems[type].activeColor : colors.gray.dark};

  svg {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    margin-top: -5px;
  }
`;
